import { AppState } from "../../reducers";
import { DropoutsState } from "./reducer";

export const dropoutsSelector = (state: AppState): DropoutsState => {
  return state.dropouts;
};
